// import router from '@/router'
import { getHotkeyCode, getHotkeysConf } from '@/store/userSettings/hotkeys'

const getInitialState = () => ({
  hotkeys_pressed: null,
  // hotkeys_dialog_pressed: null,
})

// const state = getInitialState()

let keydownEvent = null

const getters = {
  hotkeys: (state, getters) => {
    const { mergedUserSettings } = getters
    const res = getHotkeysConf({ apiConf: mergedUserSettings.hotkeys })
    return res
  },
  hotkey_pressed: (state, getters) =>
    getters.hotkeys_pressed?.length === 1 ? getters.hotkeys_pressed[0] : null,
  hotkey_pressed_bottom: (state, getters) =>
    getters.hotkeys_pressed_bottom?.length === 1 ? getters.hotkeys_pressed[0] : null,
  hotkey_pressed_dialog: (state, getters) =>
    getters.hotkeys_pressed_dialog?.length === 1 ? getters.hotkeys_pressed[0] : null,

  hotkeys_pressed: state => state.hotkeys_pressed,
  hotkeys_pressed_bottom: (state, getters) =>
    getters.query_dialogs ? null : state.hotkeys_pressed,
  hotkeys_pressed_dialog: (state, getters) =>
    getters.query_dialogs ? state.hotkeys_pressed : null,
}

const actions = {
  hotkeys_keydown({ state, commit, getters, dispatch }, e) {
    const code = getHotkeyCode(e)
    keydownEvent = e
    // console.log(e, code)

    let res = [...new Set([...(state.hotkeys_pressed || []), code])]
    res = res.filter(i => i) // Capslock is ignored by getHotkeyCode returns null
    // console.log('hotkeys_keydown', res)
    if (JSON.stringify(res) !== JSON.stringify(state.hotkeys_pressed)) {
      res = res.length ? res : null
      commit('hotkeys_set_pressed', res)
    }
  },
  hotkeys_keyup({ state, commit, getters }, e) {
    // debugger
    const code = getHotkeyCode(e)
    let res = (state.hotkeys_pressed || []).filter(c => c !== code)
    if (code === 'command') {
      res = [] // command + any - any is not released on Mac (zoom in out for example)
    }
    // console.log('hotkeys_keyup', res)
    // console.log('hotkeys_keyup', res)
    if (JSON.stringify(res) !== JSON.stringify(state.hotkeys_pressed)) {
      res = res.length ? res : null
      commit('hotkeys_set_pressed', res)
      if (!res) {
        keydownEvent = null
      }
    }
  },

  hotkeys_perform_action({ commit, getters }, { keys, hotkeyActions }) {
    Object.keys(hotkeyActions).forEach(ha => {
      const actionConf = hotkeyActions[ha]
      const combination = actionConf.keys
      const l_keys = hotkeyActions[ha].pressedKeys || keys
      if (l_keys.length === combination.length) {
        const match = actionConf.matchFn
          ? actionConf.matchFn(l_keys)
          : l_keys.filter(keyCode => !combination.includes(keyCode)).length === 0

        if (match) {
          actionConf.fn(keydownEvent)
          if (actionConf.hasPreventDefault && keydownEvent) {
            keydownEvent.preventDefault()
          }
        }
      }
    })
  },
  hotkeys_reset({ state, commit }) {
    if (state.hotkeys_pressed) {
      commit('hotkeys_set_pressed', null)
      keydownEvent = null
    }
  },
}

const mutations = {
  hotkeys_set(state, { key, value }) {
    state[key] = value
  },
  hotkeys_set_pressed(state, value) {
    state.hotkeys_pressed = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
